import { AgentDataResponse } from '@/types/Agent/agentData';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInterceptorInstance from './axiosInterceptorInstance';

export const verifyAgent = createAsyncThunk(
  'verifyAgent',
  async (req: { appId: string; agentCode: string }) => {
    try {
      const apiUrl = `/agent/GetAgentData/`;
      const response = await axiosInterceptorInstance.post<AgentDataResponse>(
        apiUrl,
        req,
      );
      return response.data;
    } catch (error) {
      return null;
    }
  },
);
